import { useDialog } from '@negar/core';
import { useI18n } from 'vue-i18n';
import { computed, ComputedRef } from 'vue';
import { AgreementItem } from '@libs/api-reference';

import { ApproveAgreementDialog } from '@/modules/user';

export default function useUserDialogs() {
  const { add: addDialog } = useDialog();

  function openApproveAgreementDialog({
    agreement,
    title,
    onConfirmCallback,
  }: {
    agreement: ComputedRef<AgreementItem | undefined>;
    title: string;
    onConfirmCallback?: () => void;
  }) {
    addDialog({
      title: title,
      content: computed(() => ({
        component: ApproveAgreementDialog,
        props: {
          selectedAgreement: agreement.value,
          onConfirmCallback: onConfirmCallback,
        },
      })),
    });
  }

  return { openApproveAgreementDialog };
}
